import React from "react"
import { useState, useContext, useCallback } from "react"
import DodoneContext from 'app/dodones/Context'

export default ({ text = "Done", attributes = {} }) => {
  const { finishDodone } = useContext(DodoneContext);
  const [isConfirmed, setIsConfimed] = useState(false);

  const onFinish = useCallback(() => {
    if(!isConfirmed) {
      setIsConfimed(true);
      return;
    }

    finishDodone(attributes);
  })

  return <div className="input-group">
           <button className="btn btn-success btn-block" onClick={ onFinish }>
             {
               isConfirmed ? 'Are you sure?' : text
             }
           </button>
         </div>
}
